// src/store/slices/sale/saleInvalidationSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SaleInvalidationDTO } from '../../../types/sale/invalidation/SaleInvalidationDTO';
import { SaleInvalidationState } from '../../../types/sale/invalidation/SaleInvalidationState';
import { SelectedSaleInfo } from '../../../types/sale/invalidation/SelectedSaleInfo';

const initialForm: SaleInvalidationDTO = {
  invalidationTypeCode: null,
  comment: '',
  generationCodeToInvalidate: '',
  replacementGenerationCode: null,
};

const initialState: SaleInvalidationState = {
  form: initialForm,
  isSubmitting: false,
  formErrors: {},
  foundSaleToInvalidate: null,
  foundReplacementSale: null,
};

const saleInvalidationSlice = createSlice({
  name: 'saleInvalidation',
  initialState,
  reducers: {
    setInvalidationField<K extends keyof SaleInvalidationDTO>(
      state,
      action: PayloadAction<{ field: K; value: SaleInvalidationDTO[K] }>
    ) {
      const { field, value } = action.payload;
      state.form[field] = value;
    },

    setInvalidationForm(state, action: PayloadAction<SaleInvalidationDTO>) {
      state.form = action.payload;
    },

    setIsSubmitting(state, action: PayloadAction<boolean>) {
      state.isSubmitting = action.payload;
    },

    setInvalidationFormErrors(state, action: PayloadAction<Record<string, string>>) {
      state.formErrors = action.payload;
    },

    clearInvalidationFormErrors(state) {
      state.formErrors = {};
    },

    resetInvalidationForm(state) {
      state.form = { ...initialForm };
      state.formErrors = {};
      state.isSubmitting = false;

      // limpiar resultados y banderas
      state.foundSaleToInvalidate = null;
      state.foundReplacementSale = null;
    },

    // 🔎 Venta a anular (resultado de búsqueda, NO el form)
    setFoundSaleToInvalidate(state, action: PayloadAction<SelectedSaleInfo | null>) {
      state.foundSaleToInvalidate = action.payload;
    },
    clearFoundSaleToInvalidate(state) {
      state.foundSaleToInvalidate = null;
    },

    // 🔁 Venta de reemplazo (resultado de búsqueda, NO el form)
    setFoundReplacementSale(state, action: PayloadAction<SelectedSaleInfo | null>) {
      state.foundReplacementSale = action.payload;
    },
    clearFoundReplacementSale(state) {
      state.foundReplacementSale = null;
    },

    // Limpia selecciones en form y resultados
    clearSelectedSales(state) {
      state.form.generationCodeToInvalidate = '';
      state.form.replacementGenerationCode = null;

      state.foundSaleToInvalidate = null;
      state.foundReplacementSale = null;

    },

    clearReplacementBranch(state) {
      state.form.replacementGenerationCode = null;          // limpia el campo del form
      state.foundReplacementSale = null;          // limpia el card
    },
  },
});

export const {
  setInvalidationField,
  setInvalidationForm,
  setIsSubmitting,
  setInvalidationFormErrors,
  clearInvalidationFormErrors,
  resetInvalidationForm,
  setFoundSaleToInvalidate,
  clearFoundSaleToInvalidate,
  setFoundReplacementSale,
  clearFoundReplacementSale,

  clearSelectedSales,
  clearReplacementBranch,
} = saleInvalidationSlice.actions;

export default saleInvalidationSlice.reducer;
